import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/create-listing/")({
  head: () => routeHead("/create-listing/"),
  beforeLoad: () => {
    throw redirect({ href: "/listeaza", statusCode: 301, replace: true });
  },
});
